import Chart from "chart.js/auto";

/**
 * @property { Chart } chart
 */
class StackedChart {
    #OPTIONS = {
        type: "bar",
        data: {
            labels: [],
            datasets: [],
        },
        options: {
            maintainAspectRatio: false,
            scales: {
                y: {
                    display: false,
                    stacked: false,
                },
                x: {
                    stacked: true,
                    display: false,
                },
            },
            plugins: {
                legend: {
                    display: false,
                },
                tooltip: {
                    rtl: true,
                    textDirection: "rtl",
                    enabled: true,
                    titleFont: {
                        family:
                            document.documentElement.lang === "en"
                                ? "iranyekan"
                                : "iranyekanfanum",
                        weight: "bold",
                    },
                    bodyFont: {
                        family:
                            document.documentElement.lang === "en"
                                ? "iranyekan"
                                : "iranyekanfanum",
                    },
                },
            },
        },
    };

    chart;

    /**
     * Creates a chart.js stacked chart
     * @param {string} selector chart element selector
     */
    constructor(selector) {
        const $ctx = $(selector);
        $ctx.attr("height", $ctx.parent().innerHeight());

        const chart_elm = document.querySelector(selector);

        this.chart = new Chart(chart_elm, this.#OPTIONS);
    }
}

export default StackedChart;
export { StackedChart };
